import type { Token } from "@/domains/core"

/**
 * Token search filtering logic
 * @param tokens
 * @param searchString
 * @returns
 */
export const tokenSearchFilter = (
  tokens: Array<Token>,
  searchString: string | null,
  nativeTokenSymbol: string,
  wrappedNativeSymbol: string,
) => {
  return tokens.filter((token: Token) => {
    if (!searchString || searchString === "") {
      return true
    }

    const nativeTokenSymbolLower = nativeTokenSymbol.toLowerCase()
    const wrappedNativeSymbolLower = wrappedNativeSymbol.toLowerCase()
    const searchLower = searchString.toLowerCase()

    // If they are searching EXACTLY for the native token symbol
    // then we filter that and only match it, we do NOT allow fuzzy matching in addition to exact matches
    if (nativeTokenSymbolLower === searchLower) {
      return token.symbol.toLowerCase() === nativeTokenSymbolLower
    }

    // If they are searching EXACTLY for the wrapped native token symbol
    // then we filter that and only match it, we do NOT allow fuzzy matching on exact matches
    if (wrappedNativeSymbolLower === searchLower) {
      return token.symbol.toLowerCase() === wrappedNativeSymbolLower
    }

    return (
      token.address.toLowerCase().includes(searchLower) ||
      token.name.toLowerCase().includes(searchLower) ||
      token.symbol.toLowerCase().includes(searchLower)
    )
  })
}
